// import { useBlocker } from 'react-router-dom'
// import type { BlockerFunction } from '@remix-run/router'
// import { useEffect, useRef } from 'react'

export const usePrompt = (onLocationChange: any, hasUnsavedChanges = false) => {
  // const blocker = useBlocker(hasUnsavedChanges ? onLocationChange : false)
  // const prevState = useRef(blocker.state)
  //
  // useEffect(() => {
  //   if (blocker.state === 'blocked') {
  //     blocker.reset()
  //   }
  //   prevState.current = blocker.state
  // }, [blocker])
}
